export default __webpack_public_path__ + "static/insurance-app-b5fa3abfb33430ad9d835f1b12e0bacf.png";